export default "<div id=\"video-container\"></div>";